import React from 'react'
import WorkshopForm from '../../Components/AdminComponents/WorkshopForm/WorkshopForm'
import AdminDash from '../../Components/AdminComponents/AdminDash/AdminDash';

function WorkshopFormPage() {
  return (
    <AdminDash>
        <WorkshopForm/>
    </AdminDash>
  )
}

export default WorkshopFormPage